import State from "../vo/State";
import ElstrCore from "elstr-frontend-4/dist/ElstrCore";

export function getState(): State {
  return ElstrCore.store?.getState();
}
